import { FieldTypes, BelongsCreatedByRefField } from 'drapcode-constant';

export const getTemplateCollectionFieldOptions = (templateCollection, collections) => {
  let options = [];
  if (templateCollection) {
    const { fields } = templateCollection;
    const nestedFields = getInnerFieldOptions(fields, collections, 'collection');
    const fieldOptions = fields
      ? fields
          .filter((e) => e.type === FieldTypes.email.id)
          .map((item) => {
            const fieldData = {
              fieldFrom: 'collection',
              fieldName: item.fieldName,
            };
            return {
              value: JSON.stringify(fieldData),
              label: item.fieldTitle.en,
            };
          })
      : [];
    options = [...fieldOptions, ...nestedFields];
  }
  return options;
};

export const getTemplateCollectionNameFieldOptions = (templateCollection, collections) => {
  let options = [];
  if (templateCollection) {
    const { fields } = templateCollection;
    const nestedFields = getInnerFieldOptions(fields, collections, 'collection');
    const fieldOptions = fields
      ? fields
          .filter((e) => e.type === FieldTypes.text.id)
          .map((item) => {
            const fieldData = {
              fieldFrom: 'collection',
              fieldName: item.fieldName,
            };
            return {
              value: JSON.stringify(fieldData),
              label: item.fieldTitle.en,
            };
          })
      : [];
    options = [...fieldOptions, ...nestedFields];
  }
  return options;
};

export const getProjectConstantOptions = (project) => {
  const projectConstants = project ? project.constants : [];
  return projectConstants
    ? projectConstants
        .filter((e) => e.constantType === 'EMAIL')
        .map((c) => ({
          value: JSON.stringify({ name: c.name, fieldFrom: 'projectConstant' }),
          label: c.name,
        }))
    : [];
};

export const getSessionOptions = (collections) => {
  let options = [];
  const userCollection = collections ? collections.find((e) => e.collectionName === 'user') : null;
  if (userCollection) {
    const { fields } = userCollection;
    const nestedFields = getInnerFieldOptions(fields, collections, 'session');
    const fieldOptions = fields
      ? fields
          .filter((e) => e.type === FieldTypes.email.id)
          .map((item) => {
            const fieldData = {
              fieldFrom: 'session',
              fieldName: item.fieldName,
            };
            return {
              value: JSON.stringify(fieldData),
              label: item.fieldTitle.en,
            };
          })
      : [];
    options = [...fieldOptions, ...nestedFields];
  }
  return options;
};

//TODO: DOCUSIGN Use BelongsCreatedByRefField from drapcode-constant
export const getInnerFieldOptions = (fields, collections, fieldFrom) => {
  let nestedFields = [];
  const referenceFields = fields
    ? fields.filter((field) => BelongsCreatedByRefField.includes(field.type))
    : [];
  if (referenceFields.length > 0) {
    referenceFields.map((field) => {
      if (field.type === FieldTypes.createdBy.id && !field.refCollection) {
        field.refCollection = {
          collectionName: 'user',
          collectionField: 'userName',
          displayType: 'dropdown',
        };
      }
      let { collectionName } = field.refCollection;
      let refFields = [];

      const refrenceCollection = collections
        ? collections.find((e) => e.collectionName === collectionName)
        : null;
      refFields =
        refrenceCollection && refrenceCollection.fields
          ? refrenceCollection.fields
              .filter((e) => e.type === FieldTypes.email.id)
              .map((nestedField) => {
                const fieldData = {
                  fieldName: field.fieldName + '.' + nestedField.fieldName,
                  fieldFrom: fieldFrom,
                };
                return {
                  value: JSON.stringify(fieldData),
                  label: field.fieldTitle.en + ':' + nestedField.fieldTitle.en,
                };
              })
          : [];
      nestedFields = [...nestedFields, ...refFields];
    });
  }
  return nestedFields;
};
